export const ticketStatus = {
  RQ: "Request",
  OP: "Open",
  CF: "Confirm",
  CI: "Checked In",
  LM: "Last Min Cancel",
  NS: "No Show",
  CO: "Checked Out",
  VD: "Voided",
  NC: "New Customer",
  BC: "Booking Confirmed",
  AC: "As Configured",
  "": "Empty",
};

export const ticketStatusList = {
  REQUEST: "RQ",
  OPEN: "OP",
  CONFIRMED: "CF",
  CHECKED_IN: "CI",
  LAST_MIN_CANCEL: "LM",
  NO_SHOW: "NS",
  CHECKED_OUT: "CO",
  VOIDED: "VD",
  NEW_CUSTOMER: "NC",
  BOOKING_CONFIRMED: "BC",

  AS_CONFIGURED: "AC",
  EMPTY: "",
};
